<ul hlmSidebarMenu>
    <li hlmSidebarMenuItem>
        <button
            type="button"
            hlmSidebarMenuButton
            size="lg"
            side="top"
            align="start"
            [tooltip]="fullName()"
            [hlmDropdownMenuTrigger]="userMenu"
            aria-label="Uživatelský účet"
        >
            <hlm-avatar>
                <span hlmAvatarFallback>{{ initials() }}</span>
            </hlm-avatar>

            <div class="grid min-w-0 flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
                <span class="truncate font-medium">{{ fullName() }}</span>
                @if (user()?.email; as email) {
                    <span class="text-muted-foreground truncate text-xs">{{ email }}</span>
                }
            </div>

            <ng-icon name="lucideChevronsUpDown" class="ms-auto group-data-[collapsible=icon]:hidden" />
        </button>

        <ng-template #userMenu>
            <div hlmDropdownMenu class="w-64">
                <div hlmDropdownMenuLabel class="p-0 font-normal">
                    <div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                        <hlm-avatar>
                            <span hlmAvatarFallback>{{ initials() }}</span>
                        </hlm-avatar>

                        <div class="grid min-w-0 flex-1 leading-tight">
                            <span class="text-foreground truncate font-medium">{{ fullName() }}</span>
                            @if (user()?.email; as email) {
                                <span class="truncate text-xs font-normal">{{ email }}</span>
                            }
                        </div>
                    </div>
                </div>

                @if (companies().length) {
                    <div hlmDropdownMenuSeparator></div>
                    <div hlmDropdownMenuLabel>Společnost</div>
                    <div hlmDropdownMenuGroup>
                        @for (company of companies(); track company.id) {
                            <button
                                type="button"
                                hlmDropdownMenuItem
                                [disabled]="isActiveCompany(company)"
                                (triggered)="switchCompany(company)"
                            >
                                @if (isActiveCompany(company)) {
                                    <ng-icon name="lucideCheck" />
                                } @else {
                                    <span class="size-4 shrink-0" aria-hidden="true"></span>
                                }
                                <span class="truncate">{{ company.name }}</span>
                            </button>
                        }
                    </div>
                }

                <div hlmDropdownMenuSeparator></div>
                <button type="button" hlmDropdownMenuItem variant="destructive" (triggered)="signOut()">
                    <ng-icon name="lucideLogOut" />
                    <span>Odhlásit se</span>
                </button>
            </div>
        </ng-template>
    </li>
</ul>
